(function () {
    'use strict';

    var module = angular.module('uwAgenda.email');
    module.directive('emailReceiverList', [EmailReceiverListFn]);

    /* email receiver list directive */
    function EmailReceiverListFn() {
        var directive = {
            restrict: 'E',
            replace: true,
            templateUrl: '/app/email/overview/templates/email-receiver-list.template.html',
            scope: {
                receivers: '='
            }
        };
        return directive;
    }
})();